// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function Core_Ui_SanctuaryButton(Props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var isActive = function (param) {
    var match = url.hash;
    if (match === "sanctuary") {
      return true;
    } else {
      return false;
    }
  };
  var onClick = function ($$event) {
    $$event.preventDefault();
    RescriptReactRouter.push("/dsensum/#sanctuary");
  };
  return React.createElement("button", {
              className: isActive(undefined) ? "bg-purple-900" : "hover:bg-purple-900",
              disabled: isActive(undefined),
              onClick: onClick
            }, React.createElement("a", {
                  className: "hidden lg:block text-xl text-purple-50 pl-5 pr-5"
                }, "⛩ SANCTUARY"), React.createElement("a", {
                  className: "lg:hidden text-xl text-purple-50 pl-5 pr-5"
                }, "⛩"));
}

var make = Core_Ui_SanctuaryButton;

export {
  make ,
}
/* react Not a pure module */
